import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';

import { Modal, ModalBody } from 'reactstrap';
import posed, { PoseGroup } from 'react-pose';

// Actions
import { gameActions } from '../actions';
import { authActions } from '../actions';

// Components
import RoundSelect from './RoundSelect';

import logo from '../assets/icon.png'; // relative path to image

// import logoKWhite from '../assets/k_logo_100_white.png' // "K" logo, solid white
import institutionLogo from '../assets/institution_logo.png'; // relative path to image
import logoWide from '../assets/simcase_wide.png'; // relative path to image
// import logoKellogg from '../assets/Kellogg_H_RGB.png'; // relative path to image
// import iconDocument from '../assets/icon_document.png' // relative path to image

/* FontAwesome */
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTimes,
  faTimesCircle,
  faInfo,
  faRoute,
  faBars,
  faListAlt,
  faPowerOff,
  faUserFriends,
  faTachometerAlt,
  faTrashAlt,
  faPlusCircle,
  faRedoAlt,
  faFileAlt,
  faQuestionCircle,
  faCheckCircle,
  faUser,
} from '@fortawesome/free-solid-svg-icons';

// Add FontAwesome icons
library.add([
  faTimes,
  faTimesCircle,
  faInfo,
  faRoute,
  faBars,
  faListAlt,
  faPowerOff,
  faUserFriends,
  faTachometerAlt,
  faTrashAlt,
  faPlusCircle,
  faRedoAlt,
  faFileAlt,
  faQuestionCircle,
  faCheckCircle,
  faUser,
]);

const Menu = posed.div({
  init: {
    opacity: 0,
  },
  enter: {
    opacity: 1,
    delayChildren: 250,
    staggerChildren: 100,
  },
  exit: {
    opacity: 0,
  },
});

const MenuClose = posed.div({
  hoverable: true,
  init: {
    scale: 1,
  },
  hover: {
    scale: 1.2,
  },
  enter: {
    opacity: 1,
    y: 0,
    transition: { duration: 250 },
  },
  exit: {
    opacity: 0,
    y: -30,
    transition: { duration: 250 },
  },
});

const MenuItem = posed.div({
  hoverable: true,
  init: {
    scale: 1,
  },
  hover: {
    scale: 1.05,
  },
  enter: {
    opacity: 1,
    y: 0,
    transition: { duration: 250 },
  },
  exit: {
    opacity: 0,
    y: 30,
    transition: { duration: 250 },
  },
});

// The Header creates links that can be used to navigate
// between routes.
class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      about: false,
      lockModal: false,
    };

    // Bindings
    this.toggleMenu = this.toggleMenu.bind(this);
    this.toggleAbout = this.toggleAbout.bind(this);
    this.toggleLock = this.toggleLock.bind(this);
    this.toggleLockModal = this.toggleLockModal.bind(this);
    this.authLogout = this.authLogout.bind(this);
  }

  toggleMenu() {
    this.setState({ open: !this.state.open });
  }

  toggleAbout() {
    this.setState({ about: !this.state.about, open: false });
  }

  toggleLockModal = () => {
    this.setState({ lockModal: !this.state.lockModal });
  };

  // Performs a request to the game api endpoint that goggles the wall
  // router.post('/:itemId/params', Controller.updateCustom);
  toggleLock() {
    const { game, dispatch } = this.props;
    const { _id } = game.data;

    // Dispatch
    dispatch(gameActions.updateGameParams({ _id, lock: !game.data.lock }));
  }

  authLogout() {
    console.log('logout');
    this.props.dispatch(authActions.logout());
  }

  render() {
    const { user, game, subtitle = true } = this.props;
    const title = game.data ? game.data.name : '';
    const fromHBP = user && user.from && user.from === 'lti-hbp' ? true : false;
    // const isInstructor =
    //   user && user.role && user.role === 'instructor' ? true : false;

    // Logo content
    const logoImg = (
      <img
        src={logo}
        className='logo'
        style={{
          height: '35px',
          marginRight: '15px',
          // marginTop: '-5px',
        }}
        alt='logo'
      />
    );

    const logoSubtitle = subtitle && game && (
      <span
        className='d-inline-block font-weight-light text-primary'
        style={{
          // lineHeight: '20px',
          maxWidth: '30vw',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}>
        {title}
      </span>
    );

    // const scProductUrl = process.env.REACT_APP_LIBRARY_URL + '?new=true';
    // let materialsLink = process.env.REACT_APP_LIBRARY_URL + '?materials=true';
    // let helpLink = 'https://simcase.help';

    // // If user comes from HBPE
    // if (fromHBP) {
    //   materialsLink = process.env.REACT_APP_HBP_PRODUCT_URL || '#';
    //   helpLink = 'https://help.hbsp.harvard.edu/hc/en-us';
    // }

    return (
      <header className='app-header' style={{ margin: '0 -15px' }}>
        <nav id='main-menu' className='navbar'>
          <div className='flex-grow-1 order-1'>
            {user?.role === 'instructor' && fromHBP && (
              <span className='navbar-brand d-flex align-items-center title fs-4'>
                {logoImg}
                <span className='d-none d-xl-inline me-3'>Loan Processing</span>
                {logoSubtitle}
              </span>
            )}

            {(user?.role !== 'instructor' || !fromHBP) && (
              <Link
                className='navbar-brand d-flex align-items-center title fs-4'
                to='/games'>
                {logoImg}
                <span className='d-none d-xl-inline me-3'>Loan Processing</span>
                {logoSubtitle}
              </Link>
            )}

            {game?.data?.sample !== true &&
              subtitle &&
              game?.data?.status === 'launched' && (
                <div className='d-inline-block' style={{ padding: '15px 0' }}>
                  <RoundSelect />
                </div>
              )}
          </div>

          {/* Note Links */}
          {/* <a
            href={materialsLink}
            className='btn btn-link text-muted ms-auto'
            target='_blank'>
            <FontAwesomeIcon className='me-1' icon='file-alt' />{' '}
            <small>Resources</small>
          </a>

          <a
            href={helpLink}
            className='btn btn-link text-muted ms-5'
            target='_blank'>
            <FontAwesomeIcon className='me-1' icon='question-circle' />{' '}
            <small>Help</small>
          </a> */}

          <div
            id='menu-buttons'
            className='d-flex justify-content-end order-3 order-sm-2'>
            {game.data &&
              game.data.status === 'launched' && [
                <button
                  key='state-toggle'
                  className={`btn ${
                    game?.data.lock ? 'btn-danger' : 'btn-success'
                  }`}
                  onClick={this.toggleLockModal}>
                  {game.data.lock ? 'Unlock' : 'Lock'}
                </button>,
                <NavLink
                  key='gd-players'
                  to={`/games/${game.data._id}/players`}
                  className='btn btn-outline-primary ms-4'
                  activeClassName='btn-primary text-white'>
                  Players
                </NavLink>,
                <NavLink
                  key='gd-debrief'
                  to={`/games/${game.data._id}/debrief/leaderboard`}
                  isActive={(match, location) =>
                    location.pathname.includes('debrief')
                  }
                  className='btn btn-outline-primary ms-4'
                  activeClassName='btn-primary text-white'>
                  Debrief
                </NavLink>,
              ]}

            {!game.data && !fromHBP && (
              <a
                href={'/admin/games/new'}
                className='btn btn-outline-primary ms-4'>
                Create Game
              </a>
            )}
          </div>

          <div
            className='menu-toggler float-end text-primary me-3 ms-4 order-2 order-sm-2'
            onClick={this.toggleMenu}>
            <FontAwesomeIcon
              icon='bars'
              size='2x'
              style={{ cursor: 'pointer' }}
            />
          </div>
        </nav>

        <PoseGroup>
          {this.state.open && (
            <Menu key='menu'>
              <div className='side-menu-wrap'>
                <div className='side-menu'>
                  <MenuClose className='menu-close' onClick={this.toggleMenu}>
                    <FontAwesomeIcon icon='times-circle' />
                  </MenuClose>

                  <MenuItem className='menu-item' onClick={this.toggleAbout}>
                    <span>
                      <FontAwesomeIcon
                        icon='route'
                        size='3x'
                        className='icon'
                      />
                      <h5 className='mb-0'>About</h5>
                      <small className='mt-0 mb-0'>About this SimCase</small>
                    </span>
                  </MenuItem>

                  {(user?.role !== 'instructor' || !fromHBP) && (
                    <MenuItem
                      className='menu-item mt-3'
                      onClick={this.toggleMenu}>
                      <NavLink to='/games' activeClassName=''>
                        <FontAwesomeIcon
                          icon='list-alt'
                          size='3x'
                          className='icon'
                        />
                        <h5 className='mb-0'>Game Sessions</h5>
                        <small className='mt-0 mb-0'>List of games</small>
                      </NavLink>
                    </MenuItem>
                  )}

                  {!fromHBP && (
                    <MenuItem
                      className='menu-item mt-3'
                      onClick={this.authLogout}>
                      <NavLink to='#' activeClassName=''>
                        <FontAwesomeIcon
                          icon='power-off'
                          size='3x'
                          className='icon'
                        />
                        <h5 className='mb-0'>Log Out</h5>
                        <small className='mt-0 mb-0'>Close your session</small>
                      </NavLink>
                    </MenuItem>
                  )}
                </div>
                <div
                  onClick={this.toggleMenu}
                  className='side-menu-overlay'></div>
              </div>
            </Menu>
          )}
        </PoseGroup>

        {/* About Modal */}
        <Modal
          isOpen={this.state.about}
          toggle={this.toggleAbout}
          centered={true}>
          <ModalBody className='text-center'>
            <div className='mt-4 mb-4 px-3'>
              <h4 className='mt-3'>About EOQ</h4>
              <p className='lead mt-4 mb-2'>
                <b>Author</b>: Christian Terwiesch
                <br />
                Andrew M. Heller Professor
              </p>
              <img
                src={institutionLogo}
                className='mt-3 mb-5'
                style={{ maxWidth: '200px', width: 'auto' }}
                alt='Logo'
              />
              <p className='lead mb-2'>
                Powered by Wharton’s Alfred P. West, Jr. Learning Lab and
                SimCase
              </p>
              <img
                src={logoWide}
                className='mt-2'
                style={{ maxWidth: '200px', width: 'auto' }}
                alt='Logo'
              />

              <p className='mt-5'>Copyright © 2023, SimCase Co.</p>

              <p className='mt-4'>
                <span className='btn btn-primary' onClick={this.toggleAbout}>
                  Continue
                </span>
              </p>
            </div>
          </ModalBody>
        </Modal>

        {/* Toogle Lock Modal */}
        <Modal
          isOpen={this.state.lockModal}
          toggle={this.toggleLockConfirm}
          centered={true}
          autoFocus={true}
          trapFocus={true}>
          <ModalBody className='text-center'>
            <div className='mt-4 mb-4 px-3'>
              <h4 className='mt-3'>Confirm</h4>
              <p className='lead mt-4 mb-2'>
                Are you sure you want to{' '}
                {game?.data?.lock ? 'open the game' : 'close the game'}?
              </p>

              <p className='mt-4'>
                <button
                  className='btn btn-lg btn-outline-primary me-3'
                  onClick={() => this.setState({ lockModal: false })}>
                  Cancel
                </button>
                <button
                  className='btn btn-lg btn-primary ms-3'
                  onClick={() => {
                    this.toggleLock();
                    this.toggleLockModal();
                  }}>
                  Confirm
                </button>
              </p>
            </div>
          </ModalBody>
        </Modal>
      </header>
    );
  }
}

function mapStateToProps(state) {
  const { authentication, game } = state;
  const { user } = authentication;
  return {
    game,
    user,
  };
}

export default connect(mapStateToProps)(Header);
